import {XauditModel} from '../xaudit.model';

export class EnumValidValueItemModel extends XauditModel {
  //static EMPTY_ENUM = '00000000-0000-0000-0000-000000000000';

  ValidValueItemId: string;
  ValidValueId: string;
  ItemName: string;
  ItemDisplayValue: string;
  ItemSValue: string;
  ItemOrder: number;
  ChildValidValueId: string;
  ChildValidValue: EnumValidValueItemModel;
  isSystem: boolean;
  ColorSchemeId: string;
  IconSet: string;
  IconIDSVG: string;
  enumValidValue?: any; // <-- allow optional

   isSelected: boolean = false;
   isPrimary: boolean = false;
}
